import { TextField } from "@mui/material";
import { inputHeight, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";

// Removes the stepper on a numeric input
// In combination with type="number" as a prop have a numeric only input
export const NumberOnlyInput = styled(TextField)`
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="number"] {
        -moz-appearance: textfield; /* Firefox */
    }
    &:not(.duration-textfield) {
        .MuiInputBase-root {
            height: ${inputHeight};
            border: 1px solid ${({ theme }: { theme: Theme }) => theme.shades.darkBorder};
            background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.blank};
        }
    }
`;
